import React, { useEffect, useMemo } from 'react';
import moment from 'moment';

import DatePickerInput from 'components/form/DatePickerInput.component';
import { useTranslation } from 'providers/GILT.provider';

import BackButton from 'booking/components/common/bw-header/BackButton';
import HeaderWrapper from 'booking/components/common/bw-header/HeaderWrapper';
import BWContent from 'booking/components/common/BWContent';
import BWFooter from 'booking/components/common/BWFooter';
import PageTitle from 'booking/components/common/PageTitle';

import CN from './RepeatBooking.module.scss';

const MAX_WEEKS = 12;

const RepeatBooking = ({ changeRepeat, changeRepeatUntil, changeRepeatFrequency, history, isEditBooking, addedServices, frequency, until }) => {
  const { t } = useTranslation();

  useEffect(() => {
    changeRepeat();
  }, [changeRepeat]);

  const appointmentDate = useMemo(() => {
    if (addedServices?.length > 0) {
      return moment(addedServices[0].start_time);
    }
    return moment();
  }, [addedServices]);

  const frequencyOptions = Array(MAX_WEEKS)
    .fill()
    .map((_, i) => String(i + 1))
    .map((num) => (
      <option key={num} value={num}>
        {num}
      </option>
    ));

  const onChangeDate = (date) => {
    changeRepeatUntil(date);
  };
  const handleSubmit = () => {
    history.goBack();
  };

  const handleBack = () => {
    changeRepeat(); // not click on 'Save changes' so toggle repeat booking back
    history.goBack();
  };

  return (
    <div data-bem="RepeatBooking" className="BookingWindow header-center">
      <HeaderWrapper>
        <BackButton onClick={handleBack} />
        <PageTitle pageTitle={t('scheduler.repeatBooking.title')} subTitle="" />
      </HeaderWrapper>

      <BWContent additionalClass="repeat-booking">
        <div>
          <div className={CN.flex}>
            <div className={CN.weeksContainer}>
              {t('scheduler.repeatBooking.every')}
              <select value={frequency} onChange={(ev) => changeRepeatFrequency(ev.target.value)} disabled={isEditBooking}>
                {frequencyOptions}
              </select>
              {t('scheduler.repeatBooking.weeksUntil')}
            </div>

            <div className={CN.pickerContainer}>
              <DatePickerInput
                tag="RepeatBooking__until"
                component={DatePickerInput.ReactDatePickerOld}
                className="repeat_booking_datepicker"
                dateFormat="YYYY-MM-DD"
                selected={until}
                locale="en-GB"
                style={{ width: '115px' }}
                onChange={onChangeDate}
                minDate={appointmentDate}
              />
            </div>
          </div>

          <div>
            <p className="repeat-info">{t('scheduler.repeatBooking.bookingsRepeatMsg')}</p>
            <p className="repeat-info2">{t('scheduler.repeatBooking.description')}</p>
          </div>
        </div>
      </BWContent>

      <BWFooter additionalClass="transparent">
        <button className="btn btn-violet pull-right repeat-booking" style={{ width: 150 }} onClick={handleSubmit}>
          {t('common.buttons.saveChanges')}
        </button>
      </BWFooter>
    </div>
  );
};

export default RepeatBooking;
